export default "__VITE_ASSET__4ysKyGy4__"